import { createRoot } from 'react-dom/client';
import { AiAssistComponent } from '../components/AiAssistComponent';

const renderAi = () => {
  const el = document.getElementById('ai_assist-button');
  const moduleContracted = el.dataset.module_contracted && el.dataset.module_contracted === 'true';

  if (el !== null) {
    const root = createRoot(el);

    root.render(<AiAssistComponent formFillID={el.dataset.form_fill_id} moduleContracted={moduleContracted} />);
  }
};

export default renderAi;
